import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import content from "./Content";
import configureState from "./state/configureState";
import { Provider } from "mobx-react";
import { HashRouter as Router } from "react-router-dom";
import cloneDeep from "lodash/cloneDeep";

const { mutator, store } = configureState({
  content: cloneDeep(content),
  alreadySeenResourceIds: [],
  completedSectionIds: [],
  lockedSectionIds: [],
});

ReactDOM.render(
  <Provider store={store} mutator={mutator}>
    <Router>
      <App />
    </Router>
  </Provider>,
  document.getElementById("root"),
);
